import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { useTheme } from "react-native-paper";

import { useGameplayStore } from "../game/stores/useGameplayStore";
import { useGameStore } from "../stores/useGameStoreFacade";
import type { ExtendedTheme } from "../theme/SynapseTheme";
import { reportModeLine } from "./ReportSummary";

/**
 * Names the puzzle above the board: an eyebrow for the mode ('Daily · Oct 5',
 * 'Tutorial', 'Random game') and start -> target in the node colours.
 */
const PuzzleHeading: React.FC = () => {
  const { colors, customColors } = useTheme() as ExtendedTheme;
  const startWord = useGameStore((s) => s.startWord);
  const targetWord = useGameStore((s) => s.targetWord);
  const isDailyChallenge = useGameStore((s) => s.isDailyChallenge);
  const isChallenge = useGameStore((s) => s.isChallenge);
  const dailyChallengeId = useGameStore((s) => s.currentDailyChallengeId);
  const isTutorial = useGameplayStore((s) => s.isTutorial);

  if (!startWord || !targetWord) return null;

  const eyebrow = reportModeLine({
    isTutorial,
    isDailyChallenge,
    isChallenge,
    dailyChallengeId,
  });

  return (
    <View
      style={styles.wrap}
      testID="puzzle-heading"
      accessibilityRole="header"
      accessibilityLabel={`${eyebrow}: ${startWord} to ${targetWord}`}
    >
      <Text style={[styles.eyebrow, { color: colors.onSurfaceVariant }]}>
        {eyebrow}
      </Text>
      <Text style={styles.pair} numberOfLines={2}>
        <Text style={{ color: customColors.startNode }}>{startWord}</Text>
        <Text style={{ color: colors.onSurfaceVariant }}> → </Text>
        <Text style={{ color: customColors.endNode }}>{targetWord}</Text>
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    alignItems: "center",
    paddingTop: 8,
    paddingHorizontal: 16,
  },
  eyebrow: {
    fontSize: 12,
    fontWeight: "600",
    letterSpacing: 1,
    textTransform: "uppercase",
  },
  pair: {
    fontSize: 20,
    lineHeight: 26,
    fontWeight: "600",
    textAlign: "center",
    marginTop: 2,
  },
});

export default PuzzleHeading;
